export const LEAD_STATUSES = ['New', 'Contacted', 'Qualified', 'Unqualified', 'Lost'] as const;
export type LeadStatus = (typeof LEAD_STATUSES)[number];

export const LEAD_PRIORITIES = ['Low', 'Medium', 'High', 'Critical'] as const;

export const STATUS_COLORS: Record<string, string> = {
  New: '#145A54',
  Contacted: '#faad14',
  Qualified: '#52c41a',
  Unqualified: '#8c8c8c',
  Lost: '#f5222d',
};

export const PRIORITY_COLORS: Record<string, string> = {
  Low: 'blue',
  Medium: 'gold',
  High: 'orange',
  Critical: 'red',
};

export const LEADS_VIEW_MODE_KEY = 'leads-view-mode';

export function leadAnnualRevenue(lead: { annual_revenue?: unknown }): number {
  const n = Number(lead.annual_revenue);
  return Number.isFinite(n) ? n : 0;
}

export function companyInitials(name: string): string {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}

export function isFollowUpOverdue(dateStr?: string | null): boolean {
  if (!dateStr) return false;
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return d.getTime() < today.getTime();
}
